import { Suspense } from 'react'
import { GtmTrackerClient, GTMTrackerProps } from './gtm-tracker-client'

export function GtmTracker({ event, data }: GTMTrackerProps) {
  return (
    <Suspense fallback={null}>
      <GtmTrackerClient event={event} data={data} />
    </Suspense>
  )
}

export default GtmTracker
